import { CardInput } from "./CardInput";
import { CardReveal } from "./CardReveal";
import {
  postVaultMessage,
  VaultFieldConfig,
  VaultFieldReadyMessage,
  addVaultMessageListener,
} from "@spp/vault";
import { isCardRevealField } from "lib/vault";
import { useRef, useState } from "react";
import { useEffect } from "react";

export const VaultField = () => {
  const [fieldConfig, setFieldConfig] = useState<VaultFieldConfig>();

  const ref = useRef({
    fieldConfig,
    ready: false,
  });

  useEffect(() => {
    ref.current = {
      ...ref.current,
      fieldConfig,
    };
  }, [fieldConfig]);

  useEffect(() => {
    const removeMessageListener = addVaultMessageListener((message) => {
      if (message.type === "Config") {
        window.fieldConfig = message.fieldConfig;
        setFieldConfig(message.fieldConfig);
      }
    });

    if (!ref.current.ready) {
      ref.current.ready = true;
      postVaultMessage<VaultFieldReadyMessage>(window.parent, {
        type: "Ready",
      });
    }

    return () => removeMessageListener();
  }, []);

  if (!fieldConfig) return null;

  return isCardRevealField(fieldConfig.fieldType) ? (
    <CardReveal fieldConfig={fieldConfig} />
  ) : (
    <CardInput fieldConfig={fieldConfig} />
  );
};
